import React, { useState, useEffect } from "react";
import axios from "axios";
import Sidebar from "./Sidebar";
import adminXB from "../assets/adminXB.png"; // Xbox logo
import adminPS from "../assets/adminPS.png"; // PlayStation logo
import adminPC from "../assets/adminPC.png"; // PC logo
import api from "../utils/api";

const SetSellCoinsPrices = () => {
  const [prices, setPrices] = useState(null);
  const [editedPrices, setEditedPrices] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchPrices();
  }, []);

  const fetchPrices = async () => {
    setLoading(true);
    try {
      const response = await api.get("/sell-prices");
      setPrices(response.data.data[0]);
      setEditedPrices(response.data.data[0]); // Initialize editable fields
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch prices. Please try again.");
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedPrices((prev) => ({ ...prev, [name]: value }));
  };

  const updatePrices = async () => {
    setLoading(true);
    try {
      await api.put(`/sell-prices/${editedPrices._id}`, editedPrices);
     
      fetchPrices(); // Refresh data
    } catch (err) {
      setError("Failed to update prices. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const platforms = [
    { name: "PS", logo: adminPS },
    { name: "PC", logo: adminPC },
    { name: "XB", logo: adminXB },
  ];

  return (
    <div className="flex flex-col md:flex-row">
      <Sidebar />
      <div className="flex-1 p-4 bg-white">
        <h1 className="text-2xl font-bold text-center mb-6">Set Sell Coin Prices</h1>
        {loading && <p>Updating Price</p>}
        {error && <p className="text-red-500">{error}</p>}
        {prices && (
          <div className="mx-auto max-w-4xl space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {platforms.map((platform) => (
                <div key={platform.name} className="flex items-center space-x-4">
                  <img
                    src={platform.logo}
                    alt={`${platform.name} logo`}
                    className="h-6 w-6 mt-4"
                  />
                  <div className="flex flex-col w-full">
                    <label className="font-medium text-lg">
                      {platform.name} Price:
                    </label>
                    <input
                      type="number"
                      name={platform.name}
                      value={editedPrices[platform.name]}
                      onChange={handleChange}
                      className="border rounded px-4 py-2"
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center">
              <button
                onClick={updatePrices}
                className="bg-primary hover:bg-yellow-300 text-black px-6 py-2 rounded shadow"
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Prices"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SetSellCoinsPrices;
